import React from 'react';

import { Behavior, TitleSmallText } from '@prisjakt/ui/text/variants';

type Props = {
  children: React.ReactNode;
};

export const ProductName = (props: Props) => {
  const { children } = props;

  return (
    <TitleSmallText
      behavior={Behavior.TwolineEllipsis}
      flex="none"
      containerProps={{ 'data-test': 'ProductName' }}
    >
      {children}
    </TitleSmallText>
  );
};
